import React, { useState, useEffect } from 'react'
import Img from 'gatsby-image'

import Layout from 'components/Layout'
import SEO from 'components/SEO'
import styled from 'util/style'
import { Select } from 'components/Select'

const Introduction = styled.div`
  margin: 0 auto 40px auto;
  font-size: 0.75em;
  max-width: 70%;

  a {
    color: #7cc1b7;
    font-weight: bold;
    text-decoration: none;
    padding-bottom: 1px;
    border-bottom: 1px solid transparent;
    transition: border-bottom-color 0.1s ease-in-out;

    &:hover {
      border-bottom-color: #7cc1b7;
    }
  }
`

const Content = styled.div`
  display: flex;

  @media (max-width: 640px) {
    display: block;
  }
`

const Filter = styled.div`
  flex: 1;
  margin-right: 40px;
`

const Results = styled.div`
  flex: 3;
`

const Suggestions = styled.div`
  display: flex;

  @media (max-width: 640px) {
    display: block;
  }
`

const Suggestion = styled.div`
  flex: 1;
  margin-right: 20px;

  img {
    max-width: 100%;
  }
`

const EmptyState = styled.div`
  width: 100%;
  padding: 0;
  font-size: 30px;
  text-align: center;

  > div {
    max-width: 60%;
  }

  @media (max-width: 640px) {
    display: none;
  }
`

const windowGlobal = typeof window !== 'undefined' && window

const waistSizeOptions = [
  { value: 32, label: '60-61 cm' },
  { value: 33, label: '62-64 cm' },
  { value: 34, label: '64-65 cm' },
  { value: 35, label: '66-68 cm' },
  { value: 36, label: '68-69 cm' },
  { value: 37, label: '70-72 cm' },
  { value: 38, label: '72-74 cm' },
  { value: 39, label: '75-78 cm' },
  { value: 40, label: '78-79 cm' },
  { value: 41, label: '80-82 cm' },
  { value: 42, label: '82-83 cm' },
  { value: 43, label: '84-86 cm' },
  { value: 44, label: '86-87 cm' },
  { value: 45, label: '88-90 cm' },
  { value: 46, label: '90-92 cm' },
  { value: 47, label: '93-95 cm' },
  { value: 48, label: '95-96 cm' },
  { value: 49, label: '97-100 cm' },
  { value: 50, label: '100-102 cm' },
  { value: 51, label: '103-106 cm' },
  { value: 52, label: '106-108 cm' },
  { value: 53, label: '109-112 cm' },
  { value: 54, label: '112-114 cm' },
  { value: 55, label: '115-118 cm' }
]

const hipSizeOptions = [
  { value: 32, label: '84-88 cm' },
  { value: 34, label: '88-92 cm' },
  { value: 36, label: '92-96 cm' },
  { value: 38, label: '96-100 cm' },
  { value: 40, label: '100-106 cm' },
  { value: 42, label: '106-110 cm' },
  { value: 44, label: '110-114 cm' },
  { value: 46, label: '114-119 cm' },
  { value: 48, label: '119-223 cm' },
  { value: 50, label: '123-131 cm' },
  { value: 52, label: '131-138 cm' },
  { value: 54, label: '138- cm' },
]

const inseamSizeOptions = [
  { value: 34, label: '49-54 cm' },
  { value: 34, label: '54-57 cm' },
  { value: 36, label: '57-60 cm' },
  { value: 38, label: '60-63 cm' },
  { value: 40, label: '63-66 cm' },
  { value: 42, label: '66-69 cm' },
  { value: 44, label: '69-71 cm' },
  { value: 46, label: '71-74 cm' },
  { value: 48, label: '74-76 cm' },
  { value: 50, label: '76-80 cm' },
  { value: 52, label: '80-82 cm' },
  { value: 54, label: '82-87 cm' },
]

const outseamSizeOptions = [
  { value: 32, label: '27-30 cm' },
  { value: 34, label: '30-33 cm' },
  { value: 36, label: '33-35 cm' },
  { value: 38, label: '35-38 cm' },
  { value: 40, label: '38-40 cm' },
  { value: 42, label: '40-42 cm' },
  { value: 44, label: '42-45 cm' },
  { value: 46, label: '45-48 cm' },
  { value: 48, label: '48-51 cm' },
  { value: 50, label: '51-54 cm' },
  { value: 52, label: '54-57 cm' },
  { value: 54, label: '57-60 cm' },
]

export function BroekenfilterPage({ data }) {
  const [waistSize, setWaistSize] = useState(
    windowGlobal.localStorage
      ? JSON.parse(windowGlobal.localStorage.getItem('gutsy-waist-size'))
      : null
  )
  const [hipSize, setHipSize] = useState(
    windowGlobal.localStorage
      ? JSON.parse(windowGlobal.localStorage.getItem('gutsy-hip-size'))
      : null
  )
  const [inseam, setInseam] = useState(
    windowGlobal.localStorage
      ? JSON.parse(windowGlobal.localStorage.getItem('gutsy-inseam'))
      : null
  )
  const [outseam, setOutseam] = useState(
    windowGlobal.localStorage
      ? JSON.parse(windowGlobal.localStorage.getItem('gutsy-outseam'))
      : null
  )

  useEffect(
    () => {
      windowGlobal.localStorage.setItem(
        'gutsy-waist-size',
        JSON.stringify(waistSize)
      )
    },
    [waistSize]
  )

  useEffect(
    () => {
      windowGlobal.localStorage.setItem(
        'gutsy-hip-size',
        JSON.stringify(hipSize)
      )
    },
    [hipSize]
  )

  useEffect(
    () => {
      windowGlobal.localStorage.setItem('gutsy-inseam', JSON.stringify(inseam))
    },
    [inseam]
  )

  useEffect(
    () => {
      windowGlobal.localStorage.setItem(
        'gutsy-outseam',
        JSON.stringify(outseam)
      )
    },
    [outseam]
  )

  return (
    <Layout>
      <SEO title="Shop" />

      <Introduction>
        Vind jij het soms ook zo lastig om de perfecte broek te vinden? Met de broekenfilter helpt Gutsy je een handje op weg! Het werkt heel easy. Je meet jezelf op (onder de vraagtekentjes vind je extra uitleg). Meet liever iets te ruim dan te smal, het is immers het belangrijkst dat de broek lekker zit. Voer vervolgens je maten in en zie de specificaties voor jouw perfecte broek!<br /><br />

        Heb je geen meetlint of herken je jezelf niet helemaal in de specificaties? Lees dan <a href="uitleg.pdf" target="_blank">hier</a> meer over hoe de filter werkt. 
        </Introduction>

      <Content>
        <Filter>
          <h3>Voer jouw maat in</h3>

          <Select
            options={waistSizeOptions}
            value={waistSize}
            label={'Taillemaat'}
            placeholder={' '}
            onChange={option => setWaistSize(option)}
            explanation
            explanationLink="/meten_taille"
          />
          <Select
            options={hipSizeOptions}
            value={hipSize}
            label={'Heupmaat'}
            placeholder={' '}
            onChange={option => setHipSize(option)}
            explanation
            explanationLink="/meten_heup"
          />
          <Select
            options={inseamSizeOptions}
            value={inseam}
            label={'Bovenbeenmaat'}
            placeholder={' '}
            onChange={option => setInseam(option)}
            explanation
            explanationLink="/meten_bovenbeen"
          />
          <Select
            options={outseamSizeOptions}
            value={outseam}
            label={'Onderbeenmaat'}
            placeholder={' '}
            onChange={option => setOutseam(option)}
            explanation
            explanationLink="/meten_onderbeen"
          />
        </Filter>

        <Results>
          {!(waistSize && hipSize && inseam && outseam) && (
            <EmptyState>
              <Img fluid={data.emptyStateImage.childImageSharp.fluid} />
            </EmptyState>
          )}

          {waistSize && hipSize && inseam && outseam && (
            <span>
              <h3 style={{ marginBottom: 0 }}>Onze tips voor jou:</h3>

              <Suggestions>
                <Suggestion>
                  {Math.abs(hipSize.value - waistSize.value) >= 4 ? (
                    <Img fluid={data.middelTailleImage.childImageSharp.fluid} />
                  ) : Math.abs(hipSize.value - waistSize.value) >= 1 ? (
                    <Img fluid={data.hogeTailleImage.childImageSharp.fluid} />
                  ) : (
                    <Img fluid={data.lageTailleImage.childImageSharp.fluid} />
                  )}
                </Suggestion>
                <Suggestion>
                  {Math.abs(hipSize.value - waistSize.value) >= 1 ? (
                    <Img
                      fluid={data.hogeRekbaarheidImage.childImageSharp.fluid}
                    />
                  ) : (
                    <Img
                      fluid={data.lageRekbaarheidImage.childImageSharp.fluid}
                    />
                  )}
                </Suggestion>
                <Suggestion>
                  {outseam.value - inseam.value >= 4 ? (
                    <Img fluid={data.flaredPijpImage.childImageSharp.fluid} />
                  ) : outseam.value - inseam.value >= 2 ? (
                    <Img fluid={data.rechtePijpImage.childImageSharp.fluid} />
                  ) : (
                    <Img fluid={data.skinnyPijpImage.childImageSharp.fluid} />
                  )}
                </Suggestion>
              </Suggestions>
            </span>
          )}
        </Results>
      </Content>
      <br /><br />

      <Introduction>
        No worries, je kunt met een gerust gevoel je maten invoeren. De gegevens die wij daaruit verkrijgen worden anoniem verwerkt voor het optimaliseren en creëren van jouw perfecte broek! Voor meer informatie daarover lees je in de privacy verklaring.
      </Introduction>
    </Layout>
  )
}

export const query = graphql`
  query filterImages {
    emptyStateImage: file(relativePath: { eq: "empty-state.png" }) {
      childImageSharp {
        fluid(maxWidth: 600) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    hogeTailleImage: file(relativePath: { eq: "filter/hoge-taille.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    middelTailleImage: file(relativePath: { eq: "filter/middel-taille.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    lageTailleImage: file(relativePath: { eq: "filter/lage-taille.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    hogeRekbaarheidImage: file(
      relativePath: { eq: "filter/hoge-rekbaarheid.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    lageRekbaarheidImage: file(
      relativePath: { eq: "filter/lage-rekbaarheid.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    skinnyPijpImage: file(relativePath: { eq: "filter/skinny-pijp.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    rechtePijpImage: file(relativePath: { eq: "filter/rechte-pijp.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    flaredPijpImage: file(relativePath: { eq: "filter/flared-pijp.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default BroekenfilterPage
